import { ApolloClient, InMemoryCache, HttpLink, ApolloLink } from '@apollo/client'

const httpLink = new HttpLink({ uri: process.env.EXPO_PUBLIC_HIGHNOTE_API_URL })

const authLink = new ApolloLink((operation, forward) => {
  const { clientToken } = operation.getContext()

  if (clientToken) {
    operation.setContext(({ headers = {} }) => ({
      headers: { ...headers, Authorization: `Bearer ${clientToken}` },
    }))
  }

  return forward(operation)
})

export const HighnoteClient = new ApolloClient({
  link: ApolloLink.from([authLink, httpLink]),
  cache: new InMemoryCache(),
})
